import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Form, Message } from 'semantic-ui-react';
import './FooterEmailCapture.css';
var defaultProps = {
  isSuccess: false,
  formFieldValues: {},
  isSubmitting: false
};
var FooterEmailCapture = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FooterEmailCapture, _React$PureComponent);
  var _super = _createSuper(FooterEmailCapture);
  function FooterEmailCapture() {
    _classCallCheck(this, FooterEmailCapture);
    return _super.apply(this, arguments);
  }
  _createClass(FooterEmailCapture, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        submitForm = _this$props.submitForm,
        updateFormFields = _this$props.updateFormFields,
        formFieldValues = _this$props.formFieldValues,
        isSuccess = _this$props.isSuccess,
        isSubmitting = _this$props.isSubmitting;
      var id = 'footer-email-capture-email-input';
      return /*#__PURE__*/React.createElement(Form, {
        size: "tiny",
        onSubmit: submitForm,
        success: isSuccess
      }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement("label", {
        htmlFor: id
      }, "Subscribe For Updates"), /*#__PURE__*/React.createElement(Form.Input, {
        action: {
          primary: true,
          icon: 'send',
          type: 'submit',
          'aria-label': 'Subscribe for updates'
        },
        id: id,
        onChange: function onChange(e) {
          return updateFormFields('email', e);
        },
        placeholder: "Your Email",
        required: true,
        type: "email",
        value: formFieldValues.email,
        disabled: isSubmitting
      })), /*#__PURE__*/React.createElement(Message, {
        success: true,
        header: "Subscribed!"
      }));
    }
  }]);
  return FooterEmailCapture;
}(React.PureComponent);
export { FooterEmailCapture as default };
FooterEmailCapture.defaultProps = defaultProps;